import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCourt: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="court"><path d="M20.25 9.25H3.75V5.5L12 2.75L20.25 5.5V9.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6 17.75L6 9.25M10 17.75L10 9.25M14 17.75L14 9.25M18 17.75V9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCourt;
